import { render } from "./Door.vue?vue&type=template&id=80308256&scoped=true"
import script from "./Door.vue?vue&type=script&lang=js"
export * from "./Door.vue?vue&type=script&lang=js"

import "./Door.vue?vue&type=style&index=0&id=80308256&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\houselayout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80308256"]])

export default __exports__